export default {
  productsHome: [],
};
